(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["s_timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("s-timeline__img--bounce-in"),t.contents[e].classList.add("s-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-s-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-banner"] && !Shopify.designMode) return;
  try {
    
  class SlideshowBanner extends HTMLElement {
    connectedCallback() {
      this.swiperEl = this.querySelector('.slideshow-banner__swiper');
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
      this.effect = this.dataset.effect === 'slide' ? 'slide' : 'fade';
      this.paginationType = this.dataset.paginationType || 'bullets';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (window.Swiper) {
        this.initSwiper();
      } else {
        // Swiper script has `defer`, wait for it to finish loading
        const swiperScript = document.querySelector('script[src*="swiper-bundle"]');
        if (swiperScript) {
          swiperScript.addEventListener('load', () => this.initSwiper(), { once: true });
        }
      }

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this) && this.swiper) this.swiper.update();
      });
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

        initSwiper() {
  const paginationEl = this.querySelector('.swiper-pagination');
  const nextEl = this.querySelector('.swiper-button-next');
  const prevEl = this.querySelector('.swiper-button-prev');
  const slideCount = this.querySelectorAll('.swiper-slide').length;

  const validTypes = ['bullets', 'fraction', 'progressbar', 'custom'];
  const isLinesStyle = this.paginationType === 'lines';
  // Swiper sendiri butuh type 'bullets' sebagai basis, kita render ulang isinya sendiri
  const swiperPaginationType = isLinesStyle
    ? 'bullets'
    : (validTypes.includes(this.paginationType) ? this.paginationType : 'bullets');

  this.swiper = new Swiper(this.swiperEl, {
    effect: this.effect,
    fadeEffect: { crossFade: true },
    loop: slideCount > 1,
    speed: 700,
    slidesPerView: 1,
    allowTouchMove: true,
    autoplay: this.autoplay && !this.reducedMotion && slideCount > 1
      ? { delay: this.autoplaySpeed, disableOnInteraction: false, pauseOnMouseEnter: true }
      : false,
    pagination: paginationEl
      ? {
          el: paginationEl,
          type: swiperPaginationType,
          clickable: true,
          renderBullet: isLinesStyle
            ? (index, className) =>
                `<span class="${className} slideshow-banner__line"><span class="slideshow-banner__line-fill"></span></span>`
            : undefined,
        }
      : false,
    navigation: nextEl && prevEl ? { nextEl, prevEl } : false,
    keyboard: { enabled: true },
    a11y: { enabled: true },
  });

  // ===== Countdown fill for "lines" pagination style =====
  if (isLinesStyle && paginationEl) {
    this.swiper.on('autoplayTimeLeft', (swiper, timeLeft, percentage) => {
      const activeFill = paginationEl.querySelector(
        '.swiper-pagination-bullet-active .slideshow-banner__line-fill'
      );
      if (activeFill) {
        activeFill.style.width = `${(1 - percentage) * 100}%`;
      }
    });

    this.swiper.on('slideChangeTransitionStart', () => {
      paginationEl.querySelectorAll('.slideshow-banner__line-fill').forEach((fill) => {
        const bullet = fill.closest('.swiper-pagination-bullet');
        if (!bullet.classList.contains('swiper-pagination-bullet-active')) {
          fill.style.width = '0%';
        }
      });
    });
  }
}
  }

  customElements.define('slideshow-banner', SlideshowBanner);

  } catch(e) { console.error(e); }
})();
})();
